// removed by extract-text-webpack-plugin
module.exports = {"container":"radio-tab__container___3hfOm","option":"radio-tab__option___1LoSP","option--selected":"radio-tab__option--selected___3S45n"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/radio-tab.scss
// module id = 1312
// module chunks = 0